import { CreateSubGroupTask } from "../../types";

export const defaultValues = (data?: CreateSubGroupTask) => {
  return {
    mr_group_sub_code: data?.mr_group_sub_code ?? "",
    mr_group_sub_name: data?.mr_group_sub_name ?? "",
    mr_group_task_id: data?.mr_group_task_id!,
    description: data?.description ?? ""
  };
};